import { useTranslation } from 'react-i18next';
import SimpleModal from '../basicModal/SimpleModal';
import { NoDataComponent } from '../../../formsAndTable/forms/formControls/NoDataComponent';
import AjaxSourcedData from '../../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { ISODate } from '../../../../types/Leads';
import { StatusHistoryItem } from '../../../../types/Tables';



type StatusHistoryModalProps = {
  isOpen: boolean;
  close: () => void;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  tableData: StatusHistoryItem[];
  columns: any[];
  defaultSortFieldId: string;
  defaultSortAsc: boolean;
  hasFilter: boolean;
};

export const StatusHistoryModal: React.FC<StatusHistoryModalProps> = ({
  isOpen,
  close,
  tableData,
  columns,
  defaultSortFieldId,
  defaultSortAsc,
  hasFilter,
}) => {


  return (
    <SimpleModal isOpen={isOpen} close={close} size="xl">
      <AjaxSourcedData
        data={tableData}
        columns={columns}
        defaultSortFieldId={defaultSortFieldId}
        defaultSortAsc={defaultSortAsc}
        hasFilter={hasFilter}
        noDataComponent={<NoDataComponent />}
      />
    </SimpleModal>
  );
};
